// extracted by mini-css-extract-plugin
module.exports = {"ProseMirror":"Indicator_ProseMirror__3DvO4","indicator":"Indicator_indicator__3XiDZ","rotate-shadow":"Indicator_rotate-shadow__Pz8JF"};